<page-headline
    linkTitle="Financials Home"
    module="financials"
    moduleIcon="fa-dollar-sign"
    moduleLink="financials"
    [pageTitle]="pageTitle"
>
</page-headline>

<mat-card class="large-card">
    <p id="page-sub-title">
        Fill in the fields below to see how many leads and loans funded you need to hit your annual
        commission goal. Your production targets will automatically populate based on your inputs.
    </p>

    <div id="sections">
        <div id="section-projections">
            <p class="section-title">Your {{ displayYear }} Goal</p>

            <div class="projection-item">
                <span class="projection-item-title">Total Commission</span>
                <div>
                    <input
                        class="projection-input project-input-model"
                        [(ngModel)]="goalSetting.annualCompensationTarget"
                        maxlength="9"
                        digitOnly
                        currencyMask
                        [options]="{ prefix: '$', precision: 0, align: 'left' }"
                    />
                </div>
            </div>

            <div class="projection-item">
                <span class="projection-item-title">Average Loan Amount</span>
                <div>
                    <input
                        class="projection-input projection-input-title"
                        [(ngModel)]="goalSetting.averageLoanAmount"
                        maxlength="9"
                        digitOnly
                        currencyMask
                        [options]="{ prefix: '$', precision: 0, align: 'left' }"
                    />
                </div>
            </div>

            <div class="projection-item">
                <span class="projection-item-title">Average Commission (BPS)</span>
                <div>
                    <input
                        class="projection-input project-input-average"
                        [(ngModel)]="goalSetting.averageCommissionBps"
                        decimalPointPrecision
                        [precision]="3"
                        maxlength="7"
                    />
                </div>

                <span *ngIf="goalSetting.averageCommissionBps == 0" style="color: red;"
                    >Average Commission (BPS) cannot be 0.</span
                >
            </div>

            <div class="projection-item">
                <span class="projection-item-title">Lead to Fund Pull-Thru (%)</span>
                <div class="Lead-item-goal">
                    <span class="projection-input projection-input-fund">
                        <input
                            max="100"
                            accuracy="2"
                            min="0"
                            [(ngModel)]="goalSetting.leadToFundPullThru"
                            digitOnly
                            maxlength="2"
                            class="Fund-pull-goal"
                        />
                        %
                    </span>
                </div>
            </div>
            <br />
            <span *ngIf="goalSetting.leadToFundPullThru == 0" style="color: red;"
                >Lead to Fund Pull-Thru (%) cannot be 0.</span
            >
        </div>

        <div id="section-goals">
            <p class="section-title">Your {{ displayYear }} Targets</p>
            <div id="goals-box">
                <div class="goal-item" *ngIf="goalTarget.fundedUnitsPerMonth">
                    <span class="goal-text">If you average</span>
                </div>
                <div class="goal-item" *ngIf="goalTarget.totalLeadsPerMonth">
                    <span class="goal-data">{{ goalTarget.totalLeadsPerMonth }} </span>
                    <span class="goal-text"><strong>leads</strong> per month</span>
                    <span class="goal-data">&nbsp;or&nbsp;{{ goalTarget.totalLeadsPerWeek }} </span>
                    <span class="goal-text"><strong>leads</strong> per week</span>
                </div>
                <div class="goal-item" *ngIf="goalTarget.fundedUnitsPerMonth">
                    <span class="goal-text">and fund &nbsp;</span>
                    <span class="goal-data">{{ goalTarget.fundedUnitsPerMonth }} </span>
                    <span class="goal-text"><strong>units</strong> per month</span>
                </div>
                <div class="goal-item" *ngIf="goalTarget.fundedUnitsPerYear">
                    <span class="goal-text">for an annual total of&nbsp;</span>
                    <span class="goal-data">{{ goalTarget.fundedUnitsPerYear }} </span>
                    <span class="goal-text"><strong>funded units</strong></span>
                </div>
                <div class="goal-item" *ngIf="goalTarget.averageCompensationPerLoan">
                    <span class="goal-text">you'll earn&nbsp;</span>
                    <span class="goal-data">{{
                        goalTarget.averageCompensationPerLoan | currency: 'USD':'symbol':'1.0-0'
                    }}</span>
                    <span class="goal-text"
                        >&nbsp;<strong>average commission</strong> per loan</span
                    >
                </div>
                <div class="goal-item" *ngIf="goalTarget.averageCompensationPerLoan">
                    <span class="goal-text">for an annual total of&nbsp;</span>
                    <span class="goal-data">{{
                        goalTarget.fundedUnitsPerYear * goalTarget.averageCompensationPerLoan
                            | currency: 'USD':'symbol':'1.0-0'
                    }}</span>
                    <span class="goal-text">&nbsp;<strong>commission</strong></span>
                </div>
            </div>
        </div>
    </div>

    <div></div>

    <div id="btn-controls mat-cal-btn">
        <div id="section-controls">
            <button mat-button class="btn-button" (click)="resetInputs()">
                reset
            </button>
            <button
                mat-focus-indicator
                mat-raised-button
                mat-button-base
                primary
                class="btn-button"
                (click)="calculateGoalTarget()"
                [disabled]="calculateBtnDisabled()"
            >
                Calculate
            </button>
        </div>
    </div>
</mat-card>
